import React, { Component } from "react";
import SideNav from "../Layout/SideNav";
import Content from "../Layout/Content";
import { API_KEY, API_URL } from "../config";
import * as actions from "../store/actions";
import { connect } from "react-redux";

class CastPage extends Component {
  render() {
    return (
      <React.Fragment>
        <SideNav />
        <Content isCastPage={true} />
      </React.Fragment>
    );
  }

  componentWillMount() {
    window.scroll({ top: 0, left: 0, behavior: "smooth" });
    this.props.changeLoadingState();
    this.props.cleanData();
    let endpoint = `${API_URL}person/popular?api_key=${API_KEY}&language=en-US&page=1`;

    this.props.fetchData(endpoint);
  }

  componentWillUnmount() {
    this.props.cleanData();
  }
}

export default connect(null, actions)(CastPage);
